import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { useBancoListar } from "@/Services/Financeiro/BancoService";

interface IBancoSelect extends ISelectComPesquisaProps {
    filtros?:Parameters<typeof useBancoListar>[0]
}
export default function BancoSelect({
    loading,
    placeholder,
    allowClear,
    filtros,
    ...rest
}:IBancoSelect) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? undefined;
    filtros = filtros ?? {
        banco : undefined
    }

    const {
        data,
        isLoading
    } = useBancoListar({
        ...filtros
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || loading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : `${m.codBanco} - ${m.nome}`
            }
        })}
    />
}